import React from "react";
import "./styles.scss";

import { Collapse } from "antd";

const { Panel } = Collapse;

const Index = () => (
  <>
    <Collapse defaultActiveKey={["1"]} expandIconPosition={"right"}>
      <Panel header="Genaral terms and conditions" key="1">
        <div className={"collapse-content"}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          <br />
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
          galley of type and scrambled it to make a type specimen book.
        </div>
      </Panel>

      <Panel header="Investment planner" key="2">
        <div className={"collapse-content"}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          <br />
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
          galley of type and scrambled it to make a type specimen book.
        </div>
      </Panel>

      <Panel header="Fixed Deposit" key="3">
        <div className={"collapse-content"}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          <br />
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
          galley of type and scrambled it to make a type specimen book.
        </div>
      </Panel>

      <Panel header="Rewards" key="4">
        <div className={"collapse-content"}>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry.
          <br />
          Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
          galley of type and scrambled it to make a type specimen book.
        </div>
      </Panel>
    </Collapse>
  </>
);

export default Index;
